/*
* Singleton class that stores in memory the last message displayed to user and allows querying information about it.
* It also stores a limited number of previous messages in case you need to inspect previous messages.
* This is only used for automation as of now. See UCE-3400 for more info.
*/
export let MessageHistory = {
  MESSAGES_TO_KEEP: 5,
  messageHistory: [],
  lastMessage: null,

  // Stores message in PdsMessageHistory.lastMessage.
  // Also inserts message at start of PdsMessageHistory.messageHistory array and drops the oldest message if we go above MESSAGES_TO_KEEP.
  add: function(message): void {
    this.lastMessage = message;
    this.messageHistory.unshift(message);
    if (this.messageHistory.length > this.MESSAGES_TO_KEEP) {
     this.messageHistory.pop();
    }
  },

  getLastMessageString: function(): string {
    return this.lastMessage ? this.lastMessage.message : '';
  },

  clickOnLastMessageLink: function(linkId: String): void {
    if (this.lastMessage && this.lastMessage.hasLinks) {
      for (let token of this.lastMessage.tokens) {
        if (token.isLinkItem && token.linkItem && token.linkItem.id === linkId) {
          // mirror PdsMessages#executeEmbeddedHtmlMessage
          token.linkItem.callback(token.linkItem);
        }
      }
    }
  },

  isLastMessageSuccess: function(): boolean {
    return this.lastMessage ? this.lastMessage.isTypeSuccess : false;
  },

  isLastMessageInfo: function(): boolean {
    return this.lastMessage ? this.lastMessage.isTypeInfo : false;
  },

  isLastMessageWarning: function(): boolean {
     return this.lastMessage ? this.lastMessage.isTypeWarning : false;
  },

  isLastMessageError: function(): boolean {
     return this.lastMessage ? this.lastMessage.isTypeError : false;
  },

  clear: function(): void {
    this.messageHistory = [];
    this.lastMessage = null;
  }
};
